import { z } from 'zod';

export enum ComponentImageType {
    THUMBNAIL = 'thumbnail',
    ISO_PICTURE = 'ISOPicture',
    FRONT = 'front',
    REAR = 'rear',
    LEFT = 'left',
    RIGHT = 'right',
    TOP = 'top',
    BOTTOM = 'bottom',
    GENERAL = 'general',
}

const file = z.object({
    id: z.string(),
    name: z.string(),
    group: z.string(),
    filename: z.string(),
    url: z.string().url(),
});

const image = z.object({
    file: z.union([file, file.shape.id]).nullable(),
    type: z.enum([
        ComponentImageType.THUMBNAIL,
        ComponentImageType.ISO_PICTURE,
        ComponentImageType.FRONT,
        ComponentImageType.REAR,
        ComponentImageType.LEFT,
        ComponentImageType.RIGHT,
        ComponentImageType.TOP,
        ComponentImageType.BOTTOM,
        ComponentImageType.GENERAL,
    ]),
});

export const images = z.array(image).default([
    {
        file: null,
        type: ComponentImageType.THUMBNAIL,
    },
    {
        file: null,
        type: ComponentImageType.ISO_PICTURE,
    },
    {
        file: null,
        type: ComponentImageType.FRONT,
    },
    {
        file: null,
        type: ComponentImageType.REAR,
    },
    {
        file: null,
        type: ComponentImageType.LEFT,
    },
    {
        file: null,
        type: ComponentImageType.RIGHT,
    },
    {
        file: null,
        type: ComponentImageType.TOP,
    },
    {
        file: null,
        type: ComponentImageType.BOTTOM,
    },
]);

export const COMPONENT_IMAGE_TYPE_OPTIONS = [
    { value: ComponentImageType.THUMBNAIL, label: 'Thumbnail' },
    { value: ComponentImageType.ISO_PICTURE, label: 'ISO Picture' },
    { value: ComponentImageType.FRONT, label: 'Front' },
    { value: ComponentImageType.REAR, label: 'Rear' },
    { value: ComponentImageType.LEFT, label: 'Left' },
    { value: ComponentImageType.RIGHT, label: 'Right' },
    { value: ComponentImageType.TOP, label: 'Top' },
    { value: ComponentImageType.BOTTOM, label: 'Bottom' },
    { value: ComponentImageType.GENERAL, label: 'General' },
];
